(() => {
  const mount = () => {
    const header = document.querySelector('[data-sf-header]');
    if (!header || header.dataset.sfScrollReady) return;
    header.dataset.sfScrollReady = 'true';
    const scrollArea = header.closest('.page-wrapper');
    const scrollHost = () => scrollArea && scrollArea.scrollHeight > scrollArea.clientHeight + 3 && /^(auto|scroll)$/.test(getComputedStyle(scrollArea).overflowY)
      ? scrollArea : document.scrollingElement || document.documentElement;
    const position = () => {
      const host = scrollHost();
      const viewport = host === scrollArea ? host.clientHeight : window.innerHeight;
      const range = Math.max(0, host.scrollHeight - viewport);
      return Math.min(range, Math.max(0, host.scrollTop));
    };
    let lastY = position();
    let anchorUntil = 0;
    let ticking = false;
    let keyboardNavigation = false;
    // Accumulated scroll travel in the current direction. Small jitter (iOS momentum,
    // rubber-band) no longer toggles the header back and forth.
    let travel = 0;
    const show = () => header.classList.remove('sf-header-away');
    const measure = () => document.documentElement.style.setProperty('--sf-nav-height', `${header.offsetHeight}px`);
    // 04.11.: The announcement bar sits inside the sticky header, which is part of the page flow.
    // Collapsing it while scrolling changed the page height and made the content (and the menu)
    // jump, especially on iPhone Safari. It now stays expanded and leaves together with the header.
    const freezeAnnouncement = true;
    let announcementHidden = false;
    header.classList.remove('sf-announcement-scrolled');
    measure();
    const resizeObserver = new ResizeObserver(measure);
    resizeObserver.observe(header);
    const update = () => {
      const y = position();
      const host = scrollHost();
      const viewport = host === scrollArea ? host.clientHeight : window.innerHeight;
      const nearBottom = window.matchMedia('(max-width: 749px)').matches && host.scrollHeight - viewport - y < Math.max(620, viewport * 1.2);
      if (nearBottom) { lastY = y; travel = 0; ticking = false; return; }
      const nextAnnouncementHidden = freezeAnnouncement ? false : (announcementHidden ? y > 15 : y > 110);
      const changedAnnouncement = nextAnnouncementHidden !== announcementHidden;
      if (changedAnnouncement) {
        announcementHidden = nextAnnouncementHidden;
        header.classList.toggle('sf-announcement-scrolled', announcementHidden);
      }
      const delta = changedAnnouncement ? 0 : y - lastY;
      if (delta !== 0 && Math.sign(delta) !== Math.sign(travel)) travel = 0;
      travel += delta;
      if (performance.now() < anchorUntil || y < 80 || header.querySelector('details[open]') || (keyboardNavigation && header.contains(document.activeElement)) || travel < -6) { show(); if (travel < -6) travel = 0; }
      else if (travel > 12) header.classList.add('sf-header-away');
      lastY = y;
      ticking = false;
    };
    document.addEventListener('keydown', event => { if (event.key === 'Tab') keyboardNavigation = true; });
    document.addEventListener('pointerdown', () => { keyboardNavigation = false; }, {passive:true});
    header.addEventListener('focusin', show);
    document.addEventListener('scroll', event => {
      if (event.target !== document && event.target !== scrollHost()) return;
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }, {passive:true,capture:true});
    window.addEventListener('resize', () => { lastY = position(); travel = 0; measure(); }, {passive:true});
    const openBrands = hash => {
      if (['#zusammenarbeiten', '#kontakt', '#SherifBrandContact'].includes(hash)) {
        const details = document.getElementById('sf-brand-details');
        if (details) details.open = true;
      }
    };
    // The visible Sherif Fadel wordmark is .sf-wordmark-text, NOT .header-logo.
    // On the homepage, scroll the actual scroll host without changing history or hash.
    // On other pages, follow its normal homepage anchor.
    window.addEventListener('click', event => {
      const logo = event.target.closest?.('a.sf-wordmark-text');
      if (!logo || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const destination = new URL(logo.href, location.href);
      if (destination.origin !== location.origin) return;
      if (destination.pathname !== location.pathname) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      header.querySelectorAll('.sf-mobile-menu[open]').forEach(menu => { menu.open = false; });
      show();
      anchorUntil = performance.now() + 1400;
      const wrapper = document.querySelector('.page-wrapper');
      const wrapperScrolls = wrapper && wrapper.scrollHeight > wrapper.clientHeight + 3 && /^(auto|scroll)$/.test(getComputedStyle(wrapper).overflowY);
      const target = wrapperScrolls ? wrapper : document.scrollingElement || document.documentElement;
      const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
      target.scrollTo({top:0,behavior});
    }, true);
    document.addEventListener('click', event => {
      const logo = event.target.closest?.('a.header-logo');
      if (!logo || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const home = new URL(logo.href, location.href);
      if (home.origin !== location.origin) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (location.pathname !== home.pathname) {
        location.assign(home.href);
        return;
      }
      header.querySelectorAll('.sf-mobile-menu[open]').forEach(menu => { menu.open = false; });
      show();
      measure();
      anchorUntil = performance.now() + 1200;
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
      const wrapper = document.querySelector('.page-wrapper');
      const host = scrollHost();
      if (host === wrapper) wrapper.scrollTo({top: 0, behavior});
      else window.scrollTo({top: 0, behavior});
    }, true);
    document.addEventListener('click', event => {
      const link = event.target.closest?.('a[href]');
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
      const url = new URL(link.href, location.href);
      if (url.origin !== location.origin || url.pathname !== location.pathname || !url.hash) return;
      const target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
      if (!target) return;
      if (url.hash === '#sf-direct-purchase' && window.matchMedia('(min-width:990px) and (pointer:fine)').matches && window.sfScrollToPurchaseOverview) return;
      event.preventDefault();
      openBrands(url.hash);
      header.querySelectorAll('.sf-mobile-menu[open]').forEach(menu => { menu.open = false; });
      show();measure();anchorUntil = performance.now() + 1200;
      history.pushState(null, '', url.hash);
      if ((url.hash === '#ueber-mich' || url.hash === '#social') && window.sfProductNavFixInstalled && target.matches('.sf-author, .sf-author-links') && window.innerWidth <= 1366) {
        // iPhone and iPad: one smooth, measured scroll. The existing desktop behavior stays intact.
        requestAnimationFrame(() => document.dispatchEvent(new CustomEvent('sf:author-nav-target',{detail:{animated:true}})));
      } else {
        requestAnimationFrame(() => target.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start'}));
      }
    });
    header.querySelectorAll('.sf-mobile-menu').forEach(menu => {
      document.addEventListener('click', event => { if (menu.open && !menu.contains(event.target)) menu.open = false; });
    });
    openBrands(location.hash);
    if (location.hash && !['#ueber-mich','#social'].includes(location.hash)) requestAnimationFrame(() => {
      const target = document.getElementById(decodeURIComponent(location.hash.slice(1)));
      if (target) { anchorUntil = performance.now() + 1200; target.scrollIntoView({block: 'start', behavior: 'instant'}); }
    });
    document.addEventListener('shopify:section:unload', () => { if (!header.isConnected) resizeObserver.disconnect(); }, {once: true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
  document.addEventListener('shopify:section:load', mount);
})();
